import { render, staticRenderFns } from "./ChannelModal.vue?vue&type=template&id=96b4cb96&scoped=true&"
import script from "./ChannelModal.vue?vue&type=script&lang=js&"
export * from "./ChannelModal.vue?vue&type=script&lang=js&"
import style0 from "./ChannelModal.vue?vue&type=style&index=0&id=96b4cb96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b4cb96",
  null
  
)

export default component.exports